// extracted by mini-css-extract-plugin
module.exports = {"freshly-published":"FreshlyPublished_freshly-published__vu4fU"};